import { useMemo, useRef } from 'react';
import { useCookies } from 'next-client-cookies';
import Link from 'components/commercetools-ui/atoms/link';
import Breadcrumb from 'components/commercetools-ui/molecules/breadcrumb';
import { TasticDataProps } from 'components/commercetools-ui/organisms/cart/types';
import { findCatPath } from 'components/commercetools-ui/organisms/product/product-details/helpers';
import { mapCategotry } from 'helpers/entity-mappers/map-category';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { flattenTree } from 'helpers/utils/flattenTree';
import { desktop } from 'helpers/utils/screensizes';
import { Category as CategoryFromEntity } from 'types/entity/category';
import { TasticProps } from '../types';

const BreadcrumbTasticCLP = ({ data, categories, params }: TasticProps<TasticDataProps>) => {
  const [isDesktopSize] = useMediaQuery(desktop);
  const { slug } = params;
  const currentCategorySlug = slug?.[0];
  const flattenedCategories = categories.flatMap((category) => flattenTree(category, 'descendants'));

  const cookies = useCookies();
  const locale = cookies.get('locale') as string;

  const category = useMemo(
    () => flattenedCategories?.find((category) => category.slug === currentCategorySlug),
    [flattenedCategories, currentCategorySlug],
  );

  const plpBreadcrumbs = findCatPath(
    categories.map((category) => mapCategotry(category, { locale })),
    category?.parentId,
  );

  const homeBreadCrumb = {
    name: data?.breadCrumbsHome || 'Home',
    categoryId: '_home',
    _url: '/',
  } as CategoryFromEntity;
  const overallBreadCrumbs = [{ ...homeBreadCrumb }, ...(plpBreadcrumbs ?? [])];

  const breadcrumbRef = useRef<HTMLAnchorElement>(null);

  return (
    <div className="mx-0 sm:mx-24 md:mx-75 lg:mx-76 xl:mx-0">
      <div className="mx-auto max-w-screen-xl transition-all duration-300">
        <div className="md:px-24 lg:px-16">
          <Breadcrumb
            className="px-20 sm:px-0"
            backCategory={overallBreadCrumbs.at(-1)}
            listClassName="w-fit"
            ref={breadcrumbRef}
          >
            {overallBreadCrumbs?.map((item, index) => (
              <Link
                key={item?.categoryId}
                link={item?._url}
                className="max-w-170 truncate text-14 lg:max-w-250"
                data-ffid={`lnk-breadcrumb-link-${index}`}
              >
                <p title={item?.name} data-ffid={`lbl-breadcrumb-category-title-${index}`} className="text-14">
                  {overallBreadCrumbs.length > 2 && index !== overallBreadCrumbs.length - 1
                    ? '...'
                    : (item?.name ?? '...')}
                </p>
              </Link>
            ))}

            <p
              className="max-w-170 cursor-default truncate text-14 font-bold lg:max-w-250"
              title={category?.name}
              data-ffid="lbl-breadcrumb-product-title"
            >
              {isDesktopSize && category?.name}
            </p>
          </Breadcrumb>
        </div>
      </div>
    </div>
  );
};

export default BreadcrumbTasticCLP;
